import { Component } from '@angular/core';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { LendersService } from '../../shared/services/lenders.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { LenderDetailsComponent } from '../lender-details/lender-details.component';
import { TableColumn } from 'src/app/shared/components/table/table-column.interface';
import { TableSearchRequest } from 'src/app/shared/components/table/table.component';

@Component({
  selector: 'app-lenders-list',
  templateUrl: './lenders-list.component.html',
  styleUrls: ['./lenders-list.component.scss']
})
export class LendersListComponent {

  lenders: any[] = [];
  resultsLength: number = 0;
  isLoadingResults: boolean = false;
  lastRequest?: TableSearchRequest;
  faPlus = faPlus;

  columns: TableColumn[] = [
    { key: 'name',     label: 'Name',   sortable: true, filterable: true },
    { key: 'isActive', label: 'Active', sortable: true, filterable: true, filterType: 'select',
      filterOptions: [
        { label: 'Yes', value: '{{bool}}true' },
        { label: 'No',  value: '{{bool}}false' }
      ]
    },
  ];

  constructor(
    private lenderService: LendersService,
    public modalService: ModalService) {
  }

  onSearch(request: TableSearchRequest) {
    this.lastRequest = request;
    this.isLoadingResults = true;
    this.lenderService.getLendersPaged(request).subscribe({
      next: data => {
        this.lenders = data.items;
        this.resultsLength = data.recordCount;
        this.isLoadingResults = false;
      },
      error: () => this.isLoadingResults = false
    });
  }

  editLender(lender: any) {
    const modalRef = this.modalService.openWithOptions(LenderDetailsComponent, { size: 'md' });
    modalRef.componentInstance.lenderId = lender.id;
    modalRef.result.then(
      (result) => { if (result) this.onSearch(this.lastRequest!); },
      () => {}
    );
  }

  addLender() {
    const modalRef = this.modalService.openWithOptions(LenderDetailsComponent, { size: 'md' });
    modalRef.result.then(
      (result) => { if (result) this.onSearch(this.lastRequest!); },
      () => {}
    );
  }
}